import httpClient from "../apiRequests/httpClient";
import { clearSessionToken, setSessionToken } from "./sessionToken";

const sessionRequest = async (email, uid) => {
  try {
    const response = await httpClient.post("/Session", {
      email,
      token: uid,
    });

    const payload = response?.data;
    if (!payload) {
      const err = new Error("No session response from server.");
      err.code = "session/empty-response";
      throw err;
    }

    if (payload.locked || payload.access === false) {
      clearSessionToken();
      return response;
    }

    if (!payload.token) {
      clearSessionToken();
      const err = new Error(
        "Login succeeded but no session token was returned. Please update the API and try again."
      );
      err.code = "session/missing-token";
      throw err;
    }

    setSessionToken(payload.token);
    return response;
  } catch (error) {
    clearSessionToken();
    console.error("Error:", error);
    if (!error.code) {
      error.code = "session/request-failed";
    }
    throw error;
  }
};

export default sessionRequest;
